<template>
  <div v-if="show_start_info" id="koe" style="width: 100vw; height: 100vh; position: fixed; left: 50%; top: 50%; transform: translateX(-50%) translateY(-50%); z-index: 100; background-color: rgba(0, 0, 0, 0.8);">
    <div v-if="show_ready_info" class="message" style="width: 80%; padding-bottom:25px; position: fixed; text-align: center; left: 50%; top: 50%; transform: translateX(-50%) translateY(-50%);">
      <p><strong>つなひきに招待されました。さっそく入場しよう！</strong></p>
      <p>このつなひきは「ちから」ではなく<br /> 「声」の大きさで勝敗が決まるよ！！ </p>
      <input name="name" v-model="user_name" type="text" placeholder="ニックネームを入力してね" style="width:200px; color:#999;margin-bottom:8px;"><a class="btn" @click.once="entry_game()" style="display:inline-block; margin:0 0 0 10px; width:80px;">会場に入る</a>
    </div>

    <div v-else-if="show_mic_info && !show_winner_info" class="message" style="width: 80%; padding-bottom:10px; position: fixed; text-align: center; left: 50%; top: 50%; transform: translateX(-50%) translateY(-50%);">
      <p><strong>勝てるコツ</strong>：マイクがついたイヤホンがあると強いです。多分。</p>
      <p><img :src="img1" style="width: 80px;" alt=""> とか <img :src="img2" style="width: 80px;" alt=""><a class="btn" @click="voice_score()">わかった。音声許可する</a> </p>
    </div>

    <div v-else class="message" style="width: 80%; padding-bottom:25px; position: fixed; text-align: center; left: 50%; top: 50%; transform: translateX(-50%) translateY(-50%);">
      <p><strong>ゲームが始まるまで待っててね！</strong></p>
      <p style="padding: 8px 0;">あなたは<strong style="padding: 0 4px;">{{ current_user.team === 'red' ? 'Aチーム' : 'Bチーム' }}</strong>だよ！</p>
      <p>ゲームを招待した人が開始ボタンを押すと始まるよ！<br>始まるまで、声が出るように準備運動をしておこう！</p>
    </div>
  </div>

  <div v-else-if="show_winner_info" style="width: 100vw; height: 100vh; position: fixed; left: 50%; top: 50%; transform: translateX(-50%) translateY(-50%); z-index: 100; background-color: rgba(0, 0, 0, 0.8);">
    <div class="message" style="width: 80%; padding-bottom:10px; position: fixed; text-align: center; left: 50%; top: 50%; transform: translateX(-50%) translateY(-50%);">
      <p><strong>ゲーム終了～～～～</strong></p>
      <p>勝敗は・・・・・・<br /><br /><span style="font-size: 28px">{{ winner_team }}</span></p>
    </div>
  </div>


  <game-area
      :red_member="red_member"
      :white_member="white_member"
      :red_score="red_score"
      :white_score="white_score"
      :game_flag="game_flag"
      :room_id="room_id"
      :game_end_time="game_end_time"
  />

  <Rope
      :red_score="red_score"
      :white_score="white_score"
  />
</template>

<script>
import firebase from 'firebase/compat/app'
import 'firebase/compat/database'
import 'firebase/compat/auth'
import GameArea from "../components/GameArea"
import Rope from "../components/Rope"
import img1 from "@/assets/koe_epw.png"
import img2 from "@/assets/koe_ep.png"

export default {
  name: 'Game',
  components: {
    GameArea,
    Rope
  },
  data() {
    return {
      game_flag: null,
      red_score: null,
      white_score: null,
      red_member: null,
      white_member: null,
      current_user: null,
      show_ready_info: true,
      show_mic_info: true,
      game_end_time: null,
      // room_id: '-MqIRZmMJ5nCXCN5hHIr'
      room_id: '',
      img1: img1,
      img2: img2,
      user_name: '',
      user_id: ''
    }
  },
  created() {
    this.room_id = this.$route.query.roomId.toString()
  },
  mounted() {
    const _this = this;

    let dataRef = firebase.database().ref('rooms/' + this.room_id);
    dataRef.on('value', (snapshot) => {
      const data = snapshot.val();
      //console.log( data );

      _this.game_flag = data.game_flag
      _this.game_end_time = data.end_time
      _this.red_score = _this.fetch_team_total_score(data.user, 'red')
      _this.white_score = _this.fetch_team_total_score(data.user, 'white')
      _this.red_member = _this.fetch_team_member(data.user, 'red')
      _this.white_member = _this.fetch_team_member(data.user, 'white')
      if ( _this.user_id !== '' ) {
        _this.current_user = data.user[_this.user_id]
      }
    });
  },
  computed: {
    winner_team: function () {
      if (this.red_score > this.white_score) {
        return 'Aチーム'
      } else if (this.red_score < this.white_score) {
        return  'Bチーム'
      }

      return '引き分け'
    },
    show_start_info: function () {
      if (this.game_flag === 'ready') {
        return true
      }

      // console.log('ユーザーID', this.user_id)
      return false
      // return this.game_flag === 'ready';
    },
    show_winner_info: function () {
      return this.game_flag === 'end';
    }
  },
  methods: {
    // この辺、値が変わっても再描画する必要ないのであれば、算出プロパティにしよう。firebaseで再読み込みが入るたびに位置が変わる
    fetch_team_total_score( user_list, target_team_name ) {
      let score = [];
      for (let k in user_list) {
        if ( user_list[k].team === target_team_name ) {
          score.push( user_list[k].score )
        }
      }

      return score.reduce(function (sum, element) {
        return sum + element;
      }, 0);
    },
    fetch_team_member( user_list, target_team_name ) {
      let member = [];
      for (let k in user_list) {
        if ( user_list[k].team === target_team_name ) {
          member.push( user_list[k] )
        }
      }

      return member
    },
    async voice_score() {
      // なんこれ
      document.body.onclick = null

      // fftのサイズを決めてる 何をするものかは分からん
      let fftsize = 15

      // サポート外だとアラートを出して、終了
      if (!navigator.mediaDevices.getUserMedia) {
        alert('getUserMedia not supported')
        return
      }
      const audio = new (window.AudioContext || window.webkitAudioContext)()
      // 音声の許可を求める
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
      // 良い感じのオブジェクトを作成する。ここからの音声は再生や編集ができます。
      const source = audio.createMediaStreamSource(stream)
      // 音声の時間と周波数を解析するAnalyserNodeを作成します。データの可視化などで使えます。
      const analyser = audio.createAnalyser() // FFT
      analyser.smoothingTimeConstant = 0 // 0-.999 0.85 ふわっとなる
      analyser.fftSize = 1 << fftsize // min:32==1<<5 max:32768==1<<15
      source.connect(analyser)

      // console.log(audio.sampleRate) // 44100 固定?
      // console.log(audio.sampleRate / analyser.fftSize + "Hz") // 分解能

      const buflen = analyser.frequencyBinCount
      const buf = new Uint8Array(buflen)

      this.show_mic_info = false
      var volume_point = 0 // 音量によるポイント
      var volume_count = 0 // 一定時間おきにサーバーへプッシュするための制御用
      var now_point = 0
      const _this = this
      const draw = function() {
        volume_count = volume_count + 1
        volume_point = volume_point + buf[3000]

        if (_this.show_winner_info) {
          stream.getAudioTracks().forEach((track) => {
            track.stop();
          })

          return
        }

        // 一定時間データが溜まったらサーバー側へプッシュする
        if(volume_count > 60){
          // TODO: 合計値を良い感じにするために、割りたい。だけど、どのレベルで割ればいいのかまだ分からん。
          let send_point = volume_point / 50;

          now_point = _this.current_user.score

          if( send_point >= 0 ) {
            let totalPoint = Math.round(send_point + now_point);

            // FIXME: ゲームスタート前に叫んだものが得点に入る事もある
            if( _this.game_flag === 'start' ) {
              firebase.database().ref('rooms/'+ _this.room_id +'/user/' + _this.user_id).update({
                score: totalPoint
              });
            }
          }

          // サーバーへプッシュ後は、音量ポイントとカウントを初期化
          volume_point = 0;
          volume_count = 0;
          now_point = 0;
        }
        analyser.getByteFrequencyData(buf)
        requestAnimationFrame(draw)
      }
      draw()
    },
    entry_game() {
      const input_name = this.user_name;
      const roomId = this.room_id;
      const _this = this;

      // 入力値不備チェック
      if(input_name == null || input_name === ''){
        alert('ニックネームを入力してください。');
      }
      // TODO: vue-routerのページ遷移前にチェックしたい。エラーページへリダイレクトしたい
      // if(roomId == null || roomId === ''){
      //   alert('予期せぬエラーが発生しました。参加用URLが誤っていないか再度確認し、エントリーしてください。');
      // }

      // ルームの存在チェック
      firebase.database().ref('rooms/' + roomId).once('value',function(snapshot){
        if(snapshot.val() == null || snapshot.val() === ''){
          alert('予期せぬエラーが発生しました。参加用URLが誤っていないか再度確認し、エントリーしてください。');
        } else {
          // 自分が既にエントリー済みかどうかチェック（同じブラウザで複数回エントリー操作した場合、最後に登録したものが自分のニックネームになる）
          // 匿名認証を行う。https://firebase.google.com/docs/auth/web/anonymous-auth?authuser=0#web-version-8
          firebase.auth().signInAnonymously();
          firebase.auth().onAuthStateChanged((user) => {
            _this.user_id = user.uid

            firebase.database().ref('rooms/' + roomId + '/user/' + user.uid).once('value',function(snapshot2){
              if(snapshot2.val() == null || snapshot2.val() === ''){
                // 初回操作時（新規ユーザーデータ作成）
                // 現在の参加人数に応じて、赤チームか白チームか振り分け
                firebase.database().ref('rooms/' + roomId + '/user').once('value',function(snapshot3){
                  let entry_team;
                  if(snapshot3.val() == null || snapshot3.val() === ''){
                    entry_team = "red";
                  }else{
                    const entry_user_count = Object.keys(snapshot3.val()).length;
                    if(entry_user_count % 2 === 0){
                      entry_team = "red";
                    }else{
                      entry_team = "white";
                    }
                  }
                  // 新規ユーザー作成（匿名認証でのキーを、データベースに保存するユーザーデータのキーとして保存する）
                  firebase.database().ref('rooms/' + roomId + '/user/' + user.uid).set({
                    name: input_name,
                    score: 0,
                    team: entry_team,
                  }, (error) => {
                    if (error) {
                      alert('作成に失敗しました。時間をおいて再度お試しください。時間をおいても解決しない場合は、他のブラウザまたは別の端末からお試しください。');
                    } else {
                      _this.show_ready_info = false;
                      _this.show_mic_info = true;
                    }
                  });
                })
              } else {
                // 同ブラウザで複数回エントリー時（自分のユーザーデータ更新）
                firebase.database().ref('rooms/' + roomId + '/user/' + user.uid).update({
                  name: input_name,
                }, (error) => {
                  if (error) {
                    alert('作成に失敗しました。時間をおいて再度お試しください。時間をおいても解決しない場合は、他のブラウザまたは別の端末からお試しください。');
                  } else {
                    _this.show_ready_info = false;
                    _this.show_mic_info = true;
                  }
                });
              }
            })
          });
        }
      })
    }
  }
}
</script>
